<ca-card>
    <div ca-card-title>{{'DATOS_SOLICITUD.CLIENTE.DATOS_COMPLEMENTARIOS.TITULO' | translate}}</div>
    <div ca-card-content>
        <div class="row mt-2">
            <div class="col-6">
                <ca-form-field>
                    <ca-label>{{'DATOS_SOLICITUD.CLIENTE.DATOS_COMPLEMENTARIOS.COMPANIA_PROCEDENCIA' | translate}}</ca-label>
                    <input caInput disabled type="text" [value]="companiaProcedencia || ''"/>
                </ca-form-field>
            </div>           
        </div>            
    </div>
</ca-card>